import React, { forwardRef } from 'react';
import { Check, Minus } from 'lucide-react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  containerClassName?: string;
  labelClassName?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, containerClassName = '', labelClassName = '', className = '', ...props }, ref) => {
    return (
      <label
        className={`inline-flex items-center gap-2 select-none ${
          props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        } ${containerClassName}`}
      >
        <div className="relative inline-flex items-center justify-center">
          <input
            type="checkbox"
            ref={ref}
            className={`peer h-4.5 w-4.5 cursor-pointer appearance-none rounded border border-outline-default/70 bg-input checked:border-accent-primary checked:bg-accent-primary indeterminate:border-accent-primary indeterminate:bg-accent-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-primary ${className}`}
            {...props}
          />
          <Check
            className="pointer-events-none absolute hidden h-3 w-3 text-glyph-inverted peer-checked:block peer-indeterminate:!hidden"
            strokeWidth={3.5}
          />
          <Minus
            className="pointer-events-none absolute hidden h-3.5 w-3.5 text-glyph-inverted peer-indeterminate:block"
            strokeWidth={3.5}
          />
        </div>
        {label && <span className={`text-sm text-glyph-secondary ${labelClassName}`}>{label}</span>}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
